var winWidth = $(window).width(),
	winHeight = $(window).height(),
	isInnerpage = ($('body').hasClass('innerpage')) ? false : true;
var anchorArray = [];
$('[data-anchor]').each(function(){
	 anchorArray.push($(this).attr('data-anchor'))
});	

$(function () {
	initFullPage();
	initSLick();
	ChangeToSvg();
	//equalsocialHeight();
	getScrollBarWidth();
	onTopCheck();
	jsAutoPlay();
	hoverVideoPlay();
	
});
$(document).ready(function () {
	// Bind events for Popup On & Off
	bindPopupEve();
	// Initialize Counter
	initCounter();
	AOS.init();

});

$(document).ready(function(){
  	$(".blognavitem").on('click', function(e) {
		e.preventDefault();
		$(".blognavitem").removeClass('active');
    	$(this).addClass('active');
    	$('html, body').animate({
      		scrollTop: $(this.hash).offset().top - 120
    	}, 600);
  	});
});



$(window).on('load', function () {
	blognavStick();
	searchheader();
	menuToggle();
	accordionToggle();
	jsAutoPlay();
	setTimeout(function () {
		addVideoPlugin();
		jsAutoPlay();
	}, 200);
	AOS.init();
});
$(window).on('resize orientationchange', function () {
	if(winWidth != $(window).width()){
	}
	//equalsocialHeight();
});

$(window).on('scroll', function () {
	blognavStick();
	onTopCheck();
});

$(document).keyup(function(e) {
    if (e.keyCode == 27) { // escape key maps to keycode `27`
    	if($('.search-input').val() == '') {
			$('.c-search-box').removeClass('searching');
		}
		closePopup();
	    if ($('body').hasClass('menuopen')) {
			$('.js-subnavigation').slideUp();
			$('.js-hasChild').removeClass('active');
			$('.c-menuScreen').fadeOut('fast', function(){
				$('body').removeClass('menuopen');
				if($('html').hasClass('fp-enabled')){
					$.fn.fullpage.setAllowScrolling(true);
				}
				$('body').css('padding-right', '');
				$('.c-menuScreen .c-btn-menu').css('right', '');
			});
		}
    }
});
function onTopCheck() {
	if ($(window).scrollTop() > 20) {
		$('body').addClass('is--not-on-top');
	} else {
		$('body').removeClass('is--not-on-top');
	}

}
function getScrollBarWidth() {
	var inner = document.createElement('p');
	inner.style.width = "100%";
	inner.style.height = "200px";
	var outer = document.createElement('div');
	outer.style.position = "absolute";
	outer.style.top = "0px";
	outer.style.left = "0px";
	outer.style.visibility = "hidden";
	outer.style.width = "200px";
	outer.style.height = "150px";
	outer.style.overflow = "hidden";
	outer.appendChild(inner);
	document.body.appendChild(outer);
	var w1 = inner.offsetWidth;
	outer.style.overflow = 'scroll';
	var w2 = inner.offsetWidth;
	if (w1 == w2) {
		w2 = outer.clientWidth;
	}
	document.body.removeChild(outer);
	return (w1 - w2);
}
function ChangeToSvg() {
	jQuery('img.tosvg').each(function () {
	    var $img = jQuery(this);
	    var imgID = $img.attr('id');
	    var imgClass = $img.attr('class');
	    var imgURL = $img.attr('src');
	    jQuery.get(imgURL, function (data) {
	      var $svg = jQuery(data).find('svg');
	      if (typeof imgID !== 'undefined') {
	        $svg = $svg.attr('id', imgID);
	      }
	      if (typeof imgClass !== 'undefined') {
	        $svg = $svg.attr('class', imgClass + ' insvg');
	      }
	      $svg = $svg.removeAttr('xmlns:a');
	      if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	        $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	      }
	      $img.replaceWith($svg);
	    }, 'xml');
	});
}
function menuToggle() {
	$('.c-btn-menu').click(function(e){
		e.preventDefault();
		if ($('body').hasClass('menuopen')) {
			$('.js-subnavigation').slideUp();
			$('.js-hasChild').removeClass('active');
			$('.c-menuScreen').fadeOut('fast', function(){
				$('body').removeClass('menuopen');
				if($('html').hasClass('fp-enabled')){
					$.fn.fullpage.setAllowScrolling(true);
				}
				if(winWidth>1199){
					$('body').css('padding-right', '');
					$('.c-menuScreen .c-btn-menu').css('right', '');
					$('.c-chat-icons, .c-fullpage-menu, .c-main-header').css('margin-right', '');
				}
			});
		} else {
			$('.c-menuScreen').fadeIn();
			if($('html').hasClass('fp-enabled')){
				$.fn.fullpage.setAllowScrolling(false);
			}
			$('body').addClass('menuopen');
			if(winWidth>1199){
				$('body').css('padding-right', getScrollBarWidth());
				$('.c-menuScreen .c-btn-menu').css('right', getScrollBarWidth());
				$('.menuopen>.c-chat-icons, .menuopen>.c-fullpage-menu, .menuopen>.c-main-header').css('margin-right', getScrollBarWidth());
			}
		}
	});
	$('.js-hasChild').click(function(e){
		 //e.preventDefault();
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$('.js-subnavigation').stop().slideUp();
		} else {
			$('.js-hasChild').removeClass('active');
			$('.js-subnavigation').stop().slideUp();
			$(this).addClass('active');
			$(this).find('.js-subnavigation').stop().slideDown();
		}
	});
}
function searchheader() {
	$('.js-search').click(function (e) {
		if(!$(this).parent().hasClass('searching')) {
			$(this).parent().addClass('searching');
			$('.search-input').focus();
		} else {
			if($(this).prev().val() == ''){
				$(this).parent().removeClass('searching');
			} else {
				console.log('searching');
			}
		}
	});
}
function equalsocialHeight() {
	var fpNav = $('.c-fullpage-menu > div').innerHeight();
	var scNav = $('.c-social > div').innerHeight();
	if(fpNav > scNav) {
		$('.c-social > div').css('height',fpNav)
	} else if(fpNav < scNav){
		$('.c-fullpage-menu > div').css('height', scNav)
	}else {
	}
}
function initFullPage() {
	if(winWidth<992){
		if($('.fp-section').hasClass('hidden-tabletP')) {
			$('.fp-section.hidden-tabletP').remove();
		}
	}
	if(winWidth>=768){
		$('#fullpage').fullpage({
			scrollOverflow: false,
			menu: '#fullpage-menu',
			anchors: anchorArray,
			scrollBar: true,
	        slidesNavigation: false,
	        controlArrows: false,
	        autoScrolling: isInnerpage,
	        slideSelector: '.fpslide',
	        onLeave: function (index, nextIndex, direction) {
	            $('.c-main-menu .nav-list a').removeClass('is--active');
	            $('.c-main-menu .nav-list li:nth-child(' + nextIndex + ') a').addClass('is--active');
	        },
	       	afterSlideLoad (section, origin, destination, direction) {
	       		if (destination == 0) {
	       			$('.slidernavigation .fpslide-prev').addClass('disabled');
	       		}
	       		else if (destination+1 == origin) {
	       			$('.slidernavigation .fpslide-next').addClass('disabled');           			
	       		}
	       		else{
	       			$('.slidernavigation .fpslide-prev').removeClass('disabled');           			
	       			$('.slidernavigation .fpslide-next').removeClass('disabled');           			
	       		}
	       	},
		});
		// $('.js-video video')[0].play();
		$('.js-scroll-down-section').click(function(e) {
			e.preventDefault();
			$.fn.fullpage.moveTo(2);
		});
		$('.fpslide-prev').click(function(e){
			e.preventDefault();
			$.fn.fullpage.moveSlideLeft();
		});
		$('.fpslide-next').click(function(e){
			e.preventDefault();
			$.fn.fullpage.moveSlideRight();
		});
	} else {
		$('.fullpagesections .sec-home').height(winHeight)
	}
}
function initSLick() {
	$('.js-contentSlider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
	  	var thisheading =  $('.js-contentSlider [data-slick-index="'+nextSlide+'"] .hd-style1').html();
        $('.serTitle').text(thisheading)
	});	
	$('.js-sliderbackground').slick({
		arrows: false,
		dots: false,
		autoplay: false,
		infinite: false,
		fade: true,
		asNavFor: '.js-contentSlider, .js-thumbSlider'
	});
	$('.js-thumbSlider').slick({
		arrows: false,
		dots: false,
		autoplay: false,
		fade: false,
		infinite: false,
		asNavFor: '.js-contentSlider, .js-sliderbackground',
	});
	$('.js-contentSlider').slick({
		arrows: true,
		dots: true,
		autoplay: false,
		fade: true,
		infinite: false,
		asNavFor: '.js-sliderbackground, .js-thumbSlider',
		appendArrows: '.js-slidernavigation',
		prevArrow: '<a href="#" class="fpslide-prev"><img src="assets/img/icons/ic-arrow-left.svg" class="tosvg svgBlack ctaicon"></a>',
		nextArrow: '<a href="#" class="fpslide-next"><img src="assets/img/icons/ic-arrow-right.svg" class="tosvg svgBlack ctaicon"></a>',
		appendDots: '.js-slidenumber',
		customPaging: function (slider, i) {
			var currentSlideLabel = "0";
			var totalSlidesLabel = "0";
			if(i > 8){
				currentSlideLabel = "";
			}
			if(slider.slideCount > 8){
				totalSlidesLabel = "";
			}
			return  currentSlideLabel + (i + 1) + '<small> / '+totalSlidesLabel + slider.slideCount + '</small>';
		},
	});
	//casestudy Sliders
	$('.js-sliderbackground1').slick({
		arrows: false,
		dots: false,
		autoplay: false,
		infinite: false,
		fade: true,
		asNavFor: '.js-contentSlider1'
	});
	$('.js-contentSlider1').slick({
		arrows: true,
		dots: true,
		autoplay: false,
		fade: false,
		infinite: false,
		asNavFor: '.js-sliderbackground1',
		appendArrows: '.js-slidernavigation1',
		prevArrow: '<a href="#" class="fpslide-prev"><img src="assets/img/icons/ic-arrow-left.svg" class="tosvg svgWhite ctaicon"></a>',
		nextArrow: '<a href="#" class="fpslide-next"><img src="assets/img/icons/ic-arrow-right.svg" class="tosvg svgWhite ctaicon"></a>',
		appendDots: '.js-slidenumber1',
		customPaging: function (slider, i) {
			var currentSlideLabel = "0";
			var totalSlidesLabel = "0";
			if(i > 8){
				currentSlideLabel = "";
			}
			if(slider.slideCount > 8){
				totalSlidesLabel = "";
			}
			return  currentSlideLabel + (i + 1) + '<small> / '+totalSlidesLabel + slider.slideCount + '</small>';
		},
	});
	$('.js-showcase').slick({
		arrows: false,
		dots: true,
		autoplay: true,
		fade: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		focusOnSelect: true,
		draggable: true,
		responsive: [
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 2,
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			},
		]
	});
	$('.js-timelinebtn').slick({
		dots: false,
		infinite: false,
		slidesToShow: 5,
		slidesToScroll: 1,
		arrows: false,
		autoplay: false,
		draggable: true,
	    asNavFor: '.js-timelineBlocks-1, .js-timelineBlocks-2',
		focusOnSelect: true,
		centerMode: false,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1,
				}
			},
		]
	});
	$(".js-timelineBlocks-1").slick({
	    dots: false,
	    infinite: false,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    arrows: false,
	    autoplay: false,
	    draggable: false,
		asNavFor: '.js-timelinebtn, .js-timelineBlocks-2',
		speed: 1000,
		adaptiveHeight: true,
	});
	$(".js-timelineBlocks-2").slick({
	    dots: true,
	    infinite: false,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    arrows: false,
	    autoplay: false,
	    draggable: true,
		asNavFor: '.js-timelinebtn, .js-timelineBlocks-1',
		speed: 1000,
		appendDots: '.js-slidenumber',
		customPaging: function (slider, i) {
			var currentSlideLabel = "0";
			var totalSlidesLabel = "0";
			if(i > 8){
				currentSlideLabel = "";
			}
			if(slider.slideCount > 8){
				totalSlidesLabel = "";
			}
			return  currentSlideLabel + (i + 1) + '<small> / '+totalSlidesLabel + slider.slideCount + '</small>';
		},
		responsive: [
			{
				breakpoint: 767,
				settings: {
					adaptiveHeight: true,
				}
			},
		]
	});
	$(".js-clientSlider").slick({
	    dots: true,
	    infinite: true,
	    slidesToShow: 1,
	    slidesToScroll: 1,
	    slidesPerRow: 5,
	    rows: 3,
	    arrows: false,
	    autoplay: true,
	    draggable: true,
		responsive: [
			{
				breakpoint: 1200,
				settings: {
				    slidesPerRow: 5,
				    rows: 3,
				}
			},
			{
				breakpoint: 991,
				settings: {
				    slidesPerRow: 4,
				    rows: 3,
				}
			},
			{
				breakpoint: 768,
				settings: {
				    slidesPerRow: 3,
				    rows: 3,
				}
			},
		]
	});
	if(winWidth < 768){
		$(".js-showcase-mobile").slick({
		    dots: false,
		    infinite: true,
		    slidesToShow: 1,
		    slidesToScroll: 1,
		    arrows: false,
		    autoplay: true,
		    draggable: true,
		    focusOnSelect: true,
		});
	}
	carouselListingInit();

}
$('.js-showcase-mobile .grid .item').click(function(e){
	e.preventDefault();
})
function carouselListingInit(){
	$('.js-carousellisting').each(function(){
		var thisArrow = $('+ .sliderOptions .js-carousellisting-arrow', this);
		console.log(thisArrow);
		$(this).slick({
			arrows: true,
			dots: false,
			autoplay: false,
			fade: false,
			infinite: false,
			slidesToShow: 3,
			slidesToScroll: 1,
			centerMode: false,
			appendArrows: thisArrow[0],
			prevArrow: '<a href="#" class="fpslide-prev"><img src="assets/img/icons/ic-arrow-left.svg" class="tosvg svgBlack ctaicon"></a>',
			nextArrow: '<a href="#" class="fpslide-next"><img src="assets/img/icons/ic-arrow-right.svg" class="tosvg svgBlack ctaicon"></a>',
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 2,
					}
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
					}
				},
			]
		});
	});
}
//Video Plugins



function openPopup(target) {
	$('html').addClass('popup-is-active');
	$(target).show();
	$(target).closest('.c-popup').show();
	setTimeout(function(){
		$(target).addClass('active');
		$(target).closest('.c-popup').addClass('popup--open');
		// console.log($(target).find('.plyr'));
		if($(target).find('.plyr').length){
			var videoInstance = $(target).find('.plyr').attr('data-video-instance');
			console.log(videoInstance);
			players[videoInstance].play();
		}

	}, 10);


	$('html').addClass('popup-is-active');
	$(target).show();
	$(target).closest('.c-popup').show();
	setTimeout(function(){
		$(target).addClass('active');
		$(target).closest('.c-popup').addClass('popup--open');

		// Play Video
		if(winWidth > 1024 && $(target).find('.plyr').length){
			var videoInstance = $(target).find('.js-video').attr('data-video-instance');
			if(players[videoInstance]){
				players[videoInstance].play();
			}
		}else if($(target).find('.js-video').length){
			$('.popup.active iframe')[0].contentWindow.postMessage('{"event":"command","func":"playVideo","args":""}', '*');
		}

	}, 10);
}

function closePopup() {
	if($('.c-popup .active').length){
		// Pause Video In Popup
		if(winWidth > 1024 && $('.c-popup .active .plyr').length){
			var videoInstance = $('.c-popup .active .plyr').attr('data-video-instance');
			if(players[videoInstance]){
				players[videoInstance].pause();
			}
		}else if($('.c-popup .active .js-video').length){
			$('.popup.active iframe')[0].contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
		}

		// Close Popup
		$('.c-popup .active').removeClass('active');
		$('.c-popup').removeClass('popup--open');
		setTimeout(function () {
			$('.c-popup .popup').hide();
			$('.c-popup').hide();
			$('html').removeClass('popup-is-active');
		}, 310);
	}
}



function addVideoPlugin() {
	if(winWidth > 1024 && $('.js-video').get(0)){
		var plyrScriptElement = document.createElement("script");
		plyrScriptElement.setAttribute('src', assetsURL+'assets/js/plyr.min.js');
		plyrScriptElement.setAttribute('async', 'true');
		document.body.appendChild(plyrScriptElement);
		
	}else{
		jsVideoDirect();
	}
}

var players = [];
var playervimeo = [];
function jsVideo() {
	// Custom player
	if($('.js-video').length){
		$('.js-video').each(function(i) {
			var thisParent = $(this).parent();
			players[i] = new Plyr(this, {
				playsinline: true,
			});
			thisParent.find('.plyr').attr('data-video-instance', i);
		});
	}
	if($('.bannerVdo').length){
		$('.bannerVdo').each(function(i) {
			var thisParent = $(this).parent();
			playervimeo[i] = new Plyr(this, {
				autoplay: true,
				playsinline: true,
				muted: true,
				loop: {
					active: true
				}
			});
			thisParent.find('.plyr').attr('data-video-instance', i);
		});
	}
}

function jsVideoDirect() {
	if($('.js-video').length){
		$('.js-video').each(function(i) {
			$(this).attr('data-video-instance', i);
			var videoId = $(this).attr('data-plyr-embed-id');
			$(this).html('<iframe width="100%" height="100%" src="https://www.youtube.com/embed/'+videoId+'?rel=0&playsinline=1&enablejsapi=1" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
		});
	}
}

function bindPopupEve() {
	// Popup Open
	$('.js-popup-link').click(function (e) {
		e.preventDefault();
		var target = $(this).attr('href');
		openPopup(target);
		$.fn.fullpage.setAllowScrolling(false);
		$('body').css('padding-right', getScrollBarWidth());
	});

	// Popup Close
	$('.js-close-popup').click(function (e) {
		e.preventDefault();
		closePopup();
		$.fn.fullpage.setAllowScrolling(true);
		$('body').css('padding-right', '');
	});
}

function initCounter(){
	if ($('#counter').length > 0) { 
		var a = 0;
		$(window).scroll(function() {

		  var oTop = $('#counter').offset().top - window.innerHeight;
		  if (a == 0 && $(window).scrollTop() > oTop) {
		    $('.counter-value').each(function() {
		      var $this = $(this),
		        countTo = $this.attr('data-count');
		      $({
		        countNum: $this.text()
		      }).animate({
		          countNum: countTo
		        },

		        {

		          duration: 2000,
		          easing: 'swing',
		          step: function() {
		            $this.text(Math.floor(this.countNum));
		          },
		          complete: function() {
		            $this.text(this.countNum);
		            //alert('finished');
		          }

		        });
		    });
		    a = 1;
		  }

		});
	}
}

/*
	By Osvaldas Valutis, www.osvaldas.info
	Available for use under the MIT License
*/
;( function ( document, window, index )
{
	var inputs = document.querySelectorAll( '.inputfile' );
	Array.prototype.forEach.call( inputs, function( input )
	{
		var label	 = input.nextElementSibling,
			labelVal = label.innerHTML;
		input.addEventListener( 'change', function( e )
		{
			var fileName = '';
			if( this.files && this.files.length > 1 )
				fileName = ( this.getAttribute( 'data-multiple-caption' ) || '' ).replace( '{count}', this.files.length );
			else
				fileName = e.target.value.split( '\\' ).pop();
			if( fileName )
				label.querySelector( 'span' ).innerHTML = fileName;
			else
				label.innerHTML = labelVal;
		});
		// Firefox bug fix
		input.addEventListener( 'focus', function(){ input.classList.add( 'has-focus' ); });
		input.addEventListener( 'blur', function(){ input.classList.remove( 'has-focus' ); });
	});
}( document, window, 0 ));


$('.js-memberitem').mouseenter(function () {
	var currentContext = $(this);

	$(".js-memberitem").removeClass('active')
	currentContext.addClass('active');

	$(".member-detail").removeClass("selected");
	$(".member-detail").removeClass('active');	
	$(currentContext.attr("href")).addClass("active");
	$(currentContext).click(function (e) {
		e.preventDefault();
		$(".js-memberitem").removeClass('active')
		currentContext.addClass('active');
		$(currentContext.attr("href")).addClass("selected");
	});
}).mouseleave(function () {
	
});

//NABEEL

if($('.js-slidingBox').length > 0){
	$(".sB-item").mouseenter(function () {
		$(".sB-item").removeClass("active");
		var currentContext = $(this);
		currentContext.addClass("active");
	}).mouseleave(function () {
		$(".sB-item").removeClass("active");
		$('.sB-item:first').addClass("active");
	});
}

// When the user scrolls the page, execute myFunction 
var headerHeight,
	navbar,
	winOff,
	sticky;

function blognavStick() {
	if ($('.sec-blognav').length > 0) { 
		headerHeight = $('.c-main-header').outerHeight();
		navbar = $(".sticky-cover");
		sticky = $(".sticky-cover").offset().top;
		winOff = $(window).scrollTop();

		console.log(sticky, winOff);
		if (sticky < (winOff + headerHeight)) {
			$('.sec-blognav').addClass("stick")
		} else {
			$('.sec-blognav').removeClass("stick");
		}
	}
}


// $("#form1").validate({
// 	errorLabelContainer: $("#form1 div.error")
// });

// function formValidation(ele) {
// 	var target = $(ele);
// 	var errContainer = $(ele+' div.error')

// 	target.validate({
// 		debug: true,
//   		success: "valid",
// 		errorLabelContainer: errContainer,
// 		submitHandler: function(form) {
// 			console.log('submitted');
// 			return false;
// 		}
// 	});	
// }

// formValidation("#form1");
// formValidation("#form2");


// var container = $('div.container');
// // validate the form when it is submitted
// var validator = $("#form2").validate({
// 	errorContainer: container,
// 	errorLabelContainer: $("ol", container),
// 	wrapper: 'li'
// });

// $(".cancel").click(function() {
// 	validator.resetForm();
// });


function jsAutoPlay() {
	$('.js-autoplay').each(function () {
		this.play();
	});
}

function hoverVideoPlay() {
    if (winWidth <= 1024) {
        $('.js-bg-video-hover video').each(function () {
            $(this)[0].play();
        });

        setTimeout(function () {
            $('.js-bg-video-hover video').each(function () {
                $(this)[0].play();
            });
        }, 1000);

        $(window).on('load', function () {
            $('.js-bg-video-hover video').each(function () {
                $(this)[0].play();
            });
        });
    } else {
        $('.js-bg-video-hover').hover(function () {
            $(this).addClass('has--hover');
            $(this).find('video')[0].play();
        }, function () {
            $(this).removeClass('has--hover');
            $(this).find('video')[0].pause();
        });
    }
}



// function accordionToggle(){
// 	$('.js-accordion').click(function(e){
// 		e.preventDefault();
// 		var teamScroll = $(this);
// 		if($(this).hasClass('active')){
// 			$(this).removeClass('active');
// 			$(this).next('.js-acc-content').stop().slideUp();
// 		} else {
// 			// var acrHeadHeight = $(this).outerHeight() * 2;
// 			// var acrContentHeight = $('.js-accordion.active').siblings('.js-acc-content').outerHeight();
// 			// var headerHeight = $('.c-main-header').outerHeight();

// 			// var cal = (acrHeadHeight + acrContentHeight + headerHeight);

// 			// console.log(acrHeadHeight , acrContentHeight , headerHeight);

// 			// $('html, body').css('overflow', 'hidden');
// 			$('.js-accordion').removeClass('active');
// 			$('.js-acc-content').stop().slideUp();
// 			$(this).addClass('active');
// 			$(this).next('.js-acc-content').stop().slideDown(function() {
// 				// $('html,body').animate({
// 			 //    	scrollTop: $(teamScroll).offset().top - 74},
// 			 //    'slow');
// 		    });
// 		}
// 	});
// }



function accordionToggle(){
	$('.js-accordion').click(function(e){
		e.preventDefault();
		var teamScroll = $(this);
		if($(this).hasClass('active')){
			$(this).removeClass('active');
			$(this).next('.js-acc-content').stop().slideUp();
		} else {
			if(winWidth > 1199) {
				$('.js-accordion.active').removeClass('active');
				$('.js-acc-content').stop().slideUp();
			}
			$(this).addClass('active');
			$(this).next('.js-acc-content').stop().slideDown(function() {
				$('html,body').animate({
			    	scrollTop: $(teamScroll).offset().top - 74},
			    'slow');
		    });
		}
	});
}


$(".js-custom-scroll").mCustomScrollbar({
	theme:"light",
	scrollbarPosition:"outside"
});



